import { useEffect, useState } from "react"
import { GetApplicantDetails, GetProspectiveDetails } from "../api/application";
import { getCurrentUser } from "../components/services/auth/authService";

const useAdmission = () => {
    const [data, setData] = useState()
    const [staging, setStaging] = useState()
    const [loading, setLoading] = useState(false);
    const user = getCurrentUser();

    useEffect(() => {
        const getAdmission = async () => {
            setLoading(true);
            try {
              const { data } = await GetProspectiveDetails(user.admission_id);
              console.log("Details", data);
              setStaging(data.stage);
              setData(data)
              setLoading(false);
            } catch (error) {
              setLoading(false);
            }
          };
          getAdmission()
    }, [staging])

    return {data, loading, staging}
}

export default useAdmission